import { render } from "./SIATokenizer.vue?vue&type=template&id=42468e21&scoped=true"
import script from "./SIATokenizer.vue?vue&type=script&lang=js"
export * from "./SIATokenizer.vue?vue&type=script&lang=js"

import "./SIATokenizer.vue?vue&type=style&index=0&id=42468e21&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42468e21"]])

export default __exports__